import { render, staticRenderFns } from "./IconCircleMinus.vue?vue&type=template&id=5d99333f&functional=true&"
import script from "./IconCircleMinus.vue?vue&type=script&lang=js&"
export * from "./IconCircleMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports